import { createSelector } from '@reduxjs/toolkit';
const selectAttachments = state => state.attachments;

export const selectIsActive = createSelector(
  selectAttachments,
  ({ widget_active }) => widget_active
);
